/**
 * Store síncrono del deep link pendiente.
 * Se usa en lugar de location.state porque Carrier y Point montan un
 * BrowserRouter anidado que no comparte el history del router de App.
 */

let pendingDeepLink = null;

export const setPendingDeepLink = deepLink => {
  pendingDeepLink = deepLink;
};

export const peekDeepLink = () => pendingDeepLink;

export const consumeDeepLink = action => {
  if (!pendingDeepLink) {
    return null;
  }
  if (action && pendingDeepLink.action !== action) {
    return null;
  }
  const current = pendingDeepLink;
  pendingDeepLink = null;
  return current;
};

export const clearDeepLink = () => {
  pendingDeepLink = null;
};
